function renderFilters() {
  var dropDown = document.querySelector('.header__filter-menu');
  var dropDownDrawer = document.querySelector('.header__filter-drawer');
  fetch("".concat(routes.all_products_collection_url, "?section_id=collection-filter")).then(function (response) {
    return response.text();
  }).then(function (text) {
    var sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
    var responseText = sectionInnerHTML.querySelector('script');
    var filters = JSON.parse(responseText.innerHTML);
    var columns = filters.columns;
    dropDown.style.setProperty('--columns', columns);
    dropDownDrawer.style.setProperty('--columns', columns);
    dropDown.innerHTML = '';
    dropDownDrawer.innerHTML = '';
    filters.filters.forEach(function (filter) {
      var li = document.createElement("li");
      var liDrawer = document.createElement("li");
      li.dataset.value = filter.value;
      liDrawer.dataset.value = filter.value;
      li.dataset.hide = true;
      liDrawer.dataset.hide = true; // if (!filter.exists) {
      //   li.dataset.hide = true;
      //   liDrawer.dataset.hide = true;
      // }

      li.classList.add('list-menu__item', 'facets__menu-item');
      liDrawer.classList.add('facets__menu-item');
      li.innerHTML = "\n          <a class=\"header__menu-item list-menu__item link link--text focus-inset caption-large\" href=\"".concat(filter.url, "\">\n            <span>\n            ").concat(filter.value, "\n            </span>\n          </a>\n        ");
      liDrawer.innerHTML = "\n          <a class=\"menu-drawer__menu-item link link--text list-menu__item focus-inset\" href=\"".concat(filter.url, "\">\n            <span>\n            ").concat(filter.value, "\n            </span>\n          </a>\n        ");
      dropDown.append(li);
      dropDownDrawer.append(liDrawer);
    });
  }).then(function (text) {
    fetch('https://services.mybcapps.com/bc-sf-filter/filter?shop=superbrastore.myshopify.com&build_filter_tree=true').then(function (response) {
      return response.json();
    }).then(function (data) {
      return data.filter.options[1].values.forEach(function (value) {
        if (value.doc_count > 0) {
          var key = value.key;
          value = key.replace('pfs:superbra_maat_option:', '');
          var filterLink = document.querySelector(".shop-by-size .list-menu__item[data-value=\"".concat(value, "\"]"));
          var filterDrawerLink = document.querySelector(".shop-by-size .facets__menu-item[data-value=\"".concat(value, "\"]"));

          if (filterLink) {
            console.log(filterLink);
            filterLink.dataset.hide = false;
          }

          if (filterDrawerLink) {
            console.log(filterDrawerLink);
            filterDrawerLink.dataset.hide = false;
          }
        }
      });
    });
  });
}

var filterBySizes = document.querySelectorAll('details.shop-by-size');
filterBySizes.forEach(function (filterBySize) {
  filterBySize.addEventListener("toggle", function () {
    renderFilters();
  }, {
    once: true
  });
}); // var dropDownMenus = document.querySelectorAll('nav.header__menu details:not(.shop-by-size)');
// dropDownMenus.forEach(dropDown => {
//   dropDown.addEventListener("toggle", function () {
//     const subMenus = dropDown.querySelectorAll('.header__submenu-part');
//     var maxHeight = 0;
//     //console.log(this.clientHeight);
//     subMenus.forEach(subMenu => {
//       if (subMenu.clientHeight > maxHeight) {
//         console.log(subMenu.clientHeight);
//         maxHeight = subMenu.clientHeight
//       }
//     });
//     console.log(maxHeight);
//     console.log('set height');
//     const headerSubmenu = this.querySelector('.header__submenu');
//     headerSubmenu.style.setProperty('height', maxHeight + 'px');
//     const header = document.getElementById('shopify-section-header');
//     //document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(header.getBoundingClientRect().bottom - this.borderOffset)}px`);
//    },  { once: true })
// });
